import { useEffect, useRef, useState } from "react";

const DELTA = 8;

// Hides the header while scrolling down and brings it back on scroll up or near the top.
export const useHideOnScroll = ({ headerRef, keepVisible, resetKey }) => {
  const [hidden, setHidden] = useState(false);
  const lastY = useRef(0);
  const ticking = useRef(false);

  useEffect(() => {
    setHidden(false);
    lastY.current = window.scrollY;
  }, [resetKey]);

  useEffect(() => {
    if (keepVisible) setHidden(false);
  }, [keepVisible]);

  useEffect(() => {
    const update = () => {
      ticking.current = false;
      const y = Math.max(window.scrollY, 0);
      const diff = y - lastY.current;
      const headerH = headerRef.current?.offsetHeight || 0;
      if (y <= headerH) setHidden(false);
      else if (Math.abs(diff) < DELTA) return;
      else if (!keepVisible) setHidden(diff > 0);
      lastY.current = y;
    };
    const onScroll = () => {
      if (!ticking.current) {
        ticking.current = true;
        requestAnimationFrame(update);
      }
    };
    const onResize = () => {
      setHidden(false);
      lastY.current = window.scrollY;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
      window.removeEventListener("orientationchange", onResize);
    };
  }, [headerRef, keepVisible]);

  return hidden;
};
